import {createAsyncThunk} from "@reduxjs/toolkit";
import {iStateMessage} from "@/customTypes/GenericReduxTypes";
import {iGenericResponse} from "@/customTypes/CommonServiceTypes";
import {curryGetThunkName} from "@/projectUtils/ReduxUtil";
import {httpStatusCodes} from "@/customTypes/NetworkTypes";
import { testimonialService } from "@/services/api/cresivoxServer";

import { iTestimonialDTO,iTestimonialResponse,REDUCER_NAME} from "./Types";
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

export const addTestimonial = createAsyncThunk<
iGenericResponse<any | null> | null,
{data:iTestimonialDTO},
{
    rejectValue: iStateMessage;
}
>(
curriedGetThunkName("addTestimonial"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({data}, {rejectWithValue}) => {
    try {
        const response = await testimonialService.createTestimonial(data);
        if (response) {
            const {httpStatusCode, data, message} = response;

            switch (httpStatusCode) {
                case httpStatusCodes.SUCCESS_OK: {
                    if (data && data.data) {
                        return {
                            data: {
                                orders: data.data,
                                message,
                            }
                        };
                    } else {
                        return rejectWithValue({
                            httpStatusCode,
                            message,
                        });
                    }
                }
                default: {
                    return rejectWithValue({
                        httpStatusCode,
                        message,
                    });
                }
            }
        } else {
            return rejectWithValue({
                message: "No response received",
            });
        }
    } catch (error) {
        return rejectWithValue({
            message: "Something went wrong",
        });
    }
},
);

  export const getTestimonialList = createAsyncThunk<
  iGenericResponse<any | null> | null,
void,
  {
      rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("TestimonialList"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async (arg, {rejectWithValue}) => {
      try {
          const response = await testimonialService.getAllTestimonial();
          if (response) {
              const {httpStatusCode, data, message} = response;

              switch (httpStatusCode) {
                  case httpStatusCodes.SUCCESS_OK: {
                      if (data && data.data) {
                          return {
                            data:{
                                httpStatusCode,
                              data: data.data,
                              message,
                            }
                              
                          };
                      } else {
                          return rejectWithValue({
                              httpStatusCode,
                              message,
                          });
                      }
                  }
                  default: {
                      return rejectWithValue({
                          httpStatusCode,
                          message,
                      });
                  }
              }
          } else {
              return rejectWithValue({
                  message: "No response received",
              });
          }
      } catch (error) {
          return rejectWithValue({
              message: "Something went wrong",
          });
      }
  },
);



export const updateTestimonial = createAsyncThunk<
iGenericResponse<any | null> | null,
{data:iTestimonialDTO,testimonialId:string},
{
    rejectValue: iStateMessage;
}
>(
curriedGetThunkName("updateTestimoniale"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({data,testimonialId}, {rejectWithValue}) => {
    try {
        const response = await testimonialService.updateTestimonial(testimonialId,data);
        if (response) {
            const {httpStatusCode, data, message} = response;

            switch (httpStatusCode) {
                case httpStatusCodes.SUCCESS_OK: {
                    if (data && data.data) {
                        return {
                            data: {
                                orders: data.data?.order,
                                message,
                            }
                        };
                    } else {
                        return rejectWithValue({
                            httpStatusCode,
                            message,
                        });
                    }
                }
                default: {
                    return rejectWithValue({
                        httpStatusCode,
                        message,
                    });
                }
            }
        } else {
            return rejectWithValue({
                message: "No response received",
            });
        }
    } catch (error) {
        return rejectWithValue({
            message: "Something went wrong",
        });
    }
},
);

export const deleteTestimonial = createAsyncThunk<
iGenericResponse<any | null> | null,
{testimonialId:string},
{
    rejectValue: iStateMessage;
}
>(
curriedGetThunkName("deleteTestimonial"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({testimonialId}, {rejectWithValue}) => {
    try {
        const response = await testimonialService.deleteTestimonial(testimonialId); // ✅ Ensure correct structure
        if (response) {
            const {httpStatusCode, data, message} = response;
            switch (httpStatusCode) {
                case httpStatusCodes.SUCCESS_OK: {
                    if (data && data.data) {
                        return {
                            data: {
                                data: data.data,
                                message,
                            }
                        };
                    } else {
                        return rejectWithValue({
                            httpStatusCode,
                            message,
                        });
                    }
                }
                default: {
                    return rejectWithValue({
                        httpStatusCode,
                        message,
                    });
                }
            }
        } else {
            return rejectWithValue({
                message: "No response received",
            });
        }
    } catch (error) {
        return rejectWithValue({
            message: "Something went wrong",
        });
    }
},
);


